import {ActionService} from 'phoenix/services/actionService';
import {
    ShareTab,
    ShareDialogTabs
} from 'sharebase/components/shareDialog/shareDialog';
import { ShareAction}  from 'sharebase/components/shareDialog/shareDialog.actions';
import { IInheritedShareableStore } from 'sharebase/domain';

const template = require('./shareCount.template');

export function ShareCountDirective() {
    return {
        restrict: 'E',
        controller: ShareCountController,
        controllerAs: 'vm',
        template,
        bindToController: true,
        scope:  {
            datastore: '='
        }
    };
}

export class ShareCountController {
    static $inject = [
        'pxActionService',
    ];

    public tabs:ShareDialogTabs = ShareDialogTabs;
    public datastore:IInheritedShareableStore;

    get sharedGroupCount() {
        const predicate = share => share.isGroup;
        return this.datastore.shares.filter(predicate).concat(this.datastore.inheritedShares.filter(predicate)).length;

}
    get sharedUserCount() {
        const predicate = share => !share.isGroup;
        return this.datastore.shares.filter(predicate).concat(this.datastore.inheritedShares.filter(predicate)).length;

    }

    get sharedLinkCount(){
        return this.datastore.links.length + this.datastore.inheritedLinks.length;
    }

    get totalShares() {
        return this.sharedUserCount + this.sharedGroupCount + this.sharedLinkCount;
    }

    constructor(
        private pxActionService:ActionService
    ) {
    }    

    public openShareDialog($event:ng.IAngularEvent, tab:ShareTab, list:number){
        let action = {
            type: ShareAction.ViewShares,
            payload: {
                tab, 
                list
            }
        };

        this.pxActionService.emit(action, $event);
    }
}





// WEBPACK FOOTER //
// ./src/sharebase-app/components/shareCount/shareCount.ts